import { render, staticRenderFns } from "./word_2.vue?vue&type=template&id=5e956541&scoped=true"
import script from "./word_2.vue?vue&type=script&lang=js"
export * from "./word_2.vue?vue&type=script&lang=js"
import style0 from "./word_2.vue?vue&type=style&index=0&id=5e956541&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e956541",
  null
  
)

export default component.exports